import { useEffect } from "react";

const projects = [
  
  
     {
    id: 1,
    title: "Loveable AI Clone",
    description: "AI Agentic flow to create web site from user prompts.",
    techStack: ["Python", "Langgraph", "Workflow Design", "DataBase"],
    image: "/project10.png",
    github: "https://github.com/tedjjj"
  },
  {
    id: 2,
    title: "OnLine-Store-Management",
    description: "AI agents that connect to an online store database and its social media, answer for costumer queries, take orders, and calls for human assistance in specific cases.",
    techStack: ["Python", "Langgraph", "Workflow Design", "DataBase"],
    image: "/3.png",
    github: "https://github.com/tedjjj"
  },
  {
    id: 3,
    title: "Sign-language-translator",
    description: "Computer vision hand detection and photo extraction, CNN to classify hand and trnslate it to letters.",
    techStack: ["Computer Vision", "Python", "CNN", "CV2"],
    image: "/project4.png",
    github: "https://github.com/tedjjj"
  },
  {
    id: 4,
    title: "Laywe Web Site (Freelance)",
    description: "Full-stack platform for Algeria's Higher Education Ministry to digitize the internship funding lifecycle across institutions: submission, eligibility checks, workflows, and tracking.",
    techStack: ["React", "Database Systems", "Workflow Design", "Full-stack"],
    image: "/project2.png",
    liveDemo: "https://capable-biscuit-e91d1f.netlify.app/",
    github: "https://github.com/tedjjj"
  },
  {
    id: 5,
    title: "University Digital Portal",
    description: "A modern student portal prototype centralizing learning resources and campus services in a single responsive interface.",
    techStack: ["React", "HTML", "CSS"],
    image: "/project1.png",
    liveDemo: "https://front-project-zeta.vercel.app/",
    github: "https://github.com/tedjjj/Front-Project"
  },
  {
    id: 6,
    title: "Apple Store Experience Website",
    description: "Product-focused e-commerce front-end for Apple devices with polished UI sections and smooth component-based interactions.",
    techStack: ["React", "UI/UX", "CSS"],
    image: "/project.png",
    liveDemo: "https://capable-biscuit-e91d1f.netlify.app/",
    github: "https://github.com/tedjjj/Apple-web-site"
  },
    {
    id: 7,
    title: "RAG Agent",
    description: "Chat bot AI avec rag.",
    techStack: ["Python", "Langgraph", "RAG"],
    image: "/project5.png",
    github: "https://github.com/tedjjj/Apple-web-site"
  },
];

function Competence() {
  
  useEffect(() => {
    const backgroundlang = ['/c.png', '/c++.webp', '/python.png', '/blender.png' , '/django.png','/java.png','/pandas.png','/php.png','/react.png'];
    const backgroundcontainer = document.getElementById('backgroundlang');
    
    if (backgroundcontainer) {
      backgroundlang.forEach((lang, index) => {
        const div = document.createElement('div');
        div.className = 'floating-lang';

         const img = document.createElement('img');
         img.src = lang;
         img.style.width = '60px';  
         img.style.height = '60px';
         div.appendChild(img); 

        div.style.left = `${Math.random() * 100}%`;
        div.style.top = `${Math.random() * 100}%`;
        div.style.animationDelay = `${Math.random() * 5}s`;  
        div.style.animationDuration = `${15 + Math.random() * 10}s`; 
        backgroundcontainer.appendChild(div);
      });
    }
  }, []); 

  return (
    <>
      <section id='competence'> 
        <div className="container">
          <div className="back-ground-lang" id="backgroundlang"></div>

          <h1>Core Skills</h1>
          <hr />
          
          <div className="simple-cont">
            <ul>
              <li style={{ color: "#7f7f7f" }}>AI Agentic Systems</li>
              <li style={{ color: "#909090" }}>Machine Learning</li>
              <li style={{ color: "#9f9f9f" }}>Deep Learning</li>
              <li style={{ color: "#b2b2b2" }}>Frontend Development</li>
              <li style={{ color: "#cbcbcb" }}>3D Design</li>
              <li style={{ color: "#ffffff" }}>Data & Database Engineering</li>
            </ul>
          </div>
        </div>
      </section>

      <section id='projects'>
        <div className="container">
          <h1>Selected Projects</h1>
          <hr />
      
          <div className="hover-cards-grid" id="projectsGrid">
            {projects && projects.length > 0 ? (
              projects.map(project => (
                <div key={project.id} className="hover-card">
                  <div 
                    className="hover-card-bg" 
                    style={project.image ? { 
                      backgroundImage: `url(${project.image})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    } : {
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                    }}
                  >
                  </div>
                  
                  <div className="hover-card-overlay">
                    <div className="hover-card-content">
                      <h3>{project.title}</h3>
                      <p>{project.description}</p>
                      
                      <div className="tech-stack">
                        {project.techStack && project.techStack.map((tech, index) => (
                          <span key={index}>{tech}</span>
                        ))}
                      </div>
                      
                      <div className="project-links">
                        <a href={project.liveDemo} target="_blank" rel="noopener noreferrer">Preview</a>
                        <a href={project.github} target="_blank" rel="noopener noreferrer">GitHub</a>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#fff' }}>No projects available</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Competence;
